import { render } from "./NewFooter.vue?vue&type=template&id=2b2e2c40&scoped=true"
const script = {}

import "./NewFooter.vue?vue&type=style&index=0&id=2b2e2c40&scoped=true&lang=css"

import exportComponent from "/Users/ratitsiklauri/DevProjects/DK-Projects/recturing-front-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2e2c40"]])

export default __exports__